import { FC } from 'react';
import { Box, Center, Spinner } from '@chakra-ui/react';

import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import ClusterToolbar from './ProductClusterToolbar';
import useProductClusterContainer from './ProductClusterContainer';
import ClusterActionModal from './ProductClusterActionModal';

const ProductClusterViewer: FC<{ toolId: number }> = ({ toolId }) => {
    const props = useProductClusterContainer();
    const { isLoading, table, actionModalProps, actionModalType, setActionModalType, currentProductCluster } = props;

    return (
        <>
            <Box mt="16px">
                {isLoading ? (
                    <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                        <Spinner />
                    </Center>
                ) : (
                    <>
                        <ClusterToolbar {...props} />
                        <DITable table={table} isPagination />
                        <TablePagination table={table} />
                    </>
                )}
            </Box>
            <ClusterActionModal
                {...actionModalProps}
                setActionModalType={setActionModalType}
                actionModalType={actionModalType}
                currentProductCluster={currentProductCluster}
            />
        </>
    );
};

export default ProductClusterViewer;
